import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

const BASE_TRIGGER_CLASSES = tv({
  base: clsx(
    // base
    "h-10 w-full flex-1 pt-1 cursor-pointer",
    // text
    "text-ui14 font-bold ",
    // border
    "border-grayScale-600 border-b-4 border-solid",
  ),
});

// この関数は、選択されているタブに基づいて動的なクラス名を返します
export const getTriggerClassName = (selectedValue: string, tabValue: string) =>
  clsx(
    BASE_TRIGGER_CLASSES.base,
    selectedValue === tabValue ? "bg-grayScale-600 text-base-0" : "bg-current hover:bg-ui-300 hover:text-base-0", // 未選択時にのみホバーが有効になる
  );
